/* eslint-disable react/prop-types */
import React from "react";
import { CDataTable } from "@coreui/react";
import LoadingAnimation from "../../loadingAnimation/loadingAnimation";

// TODO: optimize this in future if all tables in project will be replaced with core ui's table
const Table = ({
  table,
  tableWrapperId = "",
  logs,
  innerRef,
  title, // title of the table
  pagination = true,
  itemsPerPage = 10,
  tableFilter = { label: title, placeholder: "Search..." },
  sorter = false,
  extraColumns = [], // add column objs in {key: "...", label: "...", _style: {...}, sorter: <condition>, filter: <condition>, etc } format
  scopedSlots = {}, // add scoped slots in {<key of column to override>: (item, index) => ReactHTML element} where item is data under <key>
  columnHeaderSlot = {},
  overTableSlots = null, // add additional ReactHTML elements over right corner of the table,
  overrideColumnCallback = () => {}, //(header, index) => {} override column callback in extraColumns format (see above)
  onFilteredItemsChange,
  noItemsViewSlot,
  showCount = false, // add numeration for each row
  hideFirstCol,
  countTitle = "#",
  footerSlot,
  underTableSlot,
  cName = "",
  onPageChange
}) => {
  // colHeaders = columns, tableData is array of array of values,
  // load is a function, showLoad is boolean
  let { colHeaders, data } = table;

  if (showCount) {
    colHeaders = [countTitle, ...colHeaders];
    data = data.map((row, index) => [index + 1, ...row]); // adding row counter for each row
    scopedSlots = { [countTitle]: (item) => <td>{item[countTitle]}</td>, ...scopedSlots };
  }

  // TODO: find an optimal way of doing this if num of rows is too many
  // data from backend does not have keys, this is quick fix
  let tableData = [];
  Array.isArray(data) &&
    data.forEach((entry) => {
      let obj = {};
      colHeaders.forEach((header, index) => {
        obj[header] = entry[index] ?? "";
      });
      tableData.push(obj);
    });

  const dataTable = () => (
    <CDataTable
      noItemsViewSlot={noItemsViewSlot}
      innerRef={innerRef}
      columnHeaderSlot={columnHeaderSlot}
      addTableClasses={`coreUiTable ${cName}`}
      items={tableData}
      itemsPerPage={itemsPerPage}
      pagination={pagination}
      fields={[
        ...colHeaders.map((header, index) => ({
          key: header,
          label: header,
          _style: index === 0 && showCount ? { width: "5%" } : {},
          ...overrideColumnCallback(header, index)
        })), // callback in case if additional attributes needed
        ...extraColumns // extraColumns array for additional key-label pares
      ]}
      scopedSlots={scopedSlots}
      overTableSlot={overTableSlots}
      //sorterValue={{ column: "name", state: "asc" }}
      sorter={sorter}
      tableFilter={data.length > 0 ? tableFilter : false}
      onFilteredItemsChange={onFilteredItemsChange}
      footerSlot={footerSlot}
      underTableSlot={underTableSlot}
      onPageChange={onPageChange}
    />
  );

  return (
    <div
      className="client-info-bottom"
      data-testid="coreUiTable"
      id={hideFirstCol ? "hide-first-col" : ""}
    >
      <div className="cell">
        <div className="table-wrapper" id={tableWrapperId}>
          {logs ? (
            logs.loading ? (
              <LoadingAnimation text={logs.updateMessage} />
            ) : data.length > 0 ? (
              dataTable()
            ) : (
              <>
                <p className="title" style={{ paddingLeft: 0 }}>
                  Contact Logs{" "}
                  <span className="create-contact-log" onClick={() => logs.add("createLog")}>
                    Create Log
                  </span>
                </p>
                <p style={{ color: "#68686c" }}>{logs.noDataMessage}</p>
              </>
            )
          ) : (
            dataTable()
          )}
        </div>
      </div>
    </div>
  );
};

export default Table;
